import { tokens } from '@arvoreeducacao/bonsai-ds'
import type { Settings } from 'react-slick'

export const carouselBookSettings: Settings = {
  lazyLoad: 'ondemand',
  variableWidth: true,
  slidesToScroll: 7,
  slidesToShow: 7,
  dots: false,
  infinite: false,
  speed: 500,
  swipeToSlide: true,
  responsive: [
    {
      breakpoint: tokens.breakpoints.desktopXlarge,
      settings: {
        slidesToScroll: 6,
        slidesToShow: 6
      }
    },
    {
      breakpoint: tokens.breakpoints.desktopLarge,
      settings: {
        slidesToScroll: 5,
        slidesToShow: 5
      }
    },
    {
      breakpoint: tokens.breakpoints.desktop,
      settings: {
        slidesToScroll: 3,
        slidesToShow: 4
      }
    },
    {
      breakpoint: tokens.breakpoints.tablet,
      settings: {
        slidesToScroll: 2,
        slidesToShow: 4
      }
    },
    {
      breakpoint: tokens.sizes.smScreen,
      settings: {
        slidesToScroll: 1,
        slidesToShow: 2
      }
    }
  ]
}

export const carouselHighlightedBooksSettings: Settings = {
  lazyLoad: 'ondemand',
  variableWidth: true,
  slidesToScroll: 6,
  slidesToShow: 6,
  dots: false,
  infinite: false,
  speed: 500,
  swipeToSlide: true,
  responsive: [
    {
      breakpoint: tokens.breakpoints.desktopXlarge,
      settings: {
        slidesToScroll: 5,
        slidesToShow: 5
      }
    },
    {
      breakpoint: tokens.breakpoints.desktopLarge,
      settings: {
        slidesToScroll: 4,
        slidesToShow: 4
      }
    },
    {
      breakpoint: tokens.breakpoints.desktop,
      settings: {
        slidesToScroll: 3,
        slidesToShow: 3
      }
    },
    {
      breakpoint: tokens.breakpoints.tablet,
      settings: {
        slidesToScroll: 2,
        slidesToShow: 3
      }
    },
    {
      breakpoint: tokens.sizes.smScreen,
      settings: {
        slidesToScroll: 1,
        slidesToShow: 1
      }
    }
  ]
}

export const carouselAudiobookSettings: Settings = {
  lazyLoad: 'ondemand',
  variableWidth: true,
  slidesToScroll: 5,
  slidesToShow: 5,
  dots: false,
  infinite: false,
  speed: 500,
  swipeToSlide: true,
  responsive: [
    {
      breakpoint: tokens.breakpoints.desktopXlarge,
      settings: {
        slidesToScroll: 5,
        slidesToShow: 5
      }
    },
    {
      breakpoint: tokens.breakpoints.desktopLarge,
      settings: {
        slidesToScroll: 4,
        slidesToShow: 4
      }
    },
    {
      breakpoint: tokens.breakpoints.desktop,
      settings: {
        slidesToScroll: 3,
        slidesToShow: 3
      }
    },
    {
      breakpoint: tokens.breakpoints.tablet,
      settings: {
        slidesToScroll: 2,
        slidesToShow: 2
      }
    },
    {
      breakpoint: tokens.sizes.smScreen,
      settings: {
        slidesToScroll: 1,
        slidesToShow: 1
      }
    }
  ]
}

export const carouselHighlightedAudiobookSettings: Settings = {
  lazyLoad: 'ondemand',
  variableWidth: true,
  slidesToScroll: 4,
  slidesToShow: 4,
  dots: false,
  infinite: false,
  speed: 500,
  swipeToSlide: true,
  responsive: [
    {
      breakpoint: tokens.breakpoints.desktopXlarge,
      settings: {
        slidesToScroll: 5,
        slidesToShow: 5
      }
    },
    {
      breakpoint: tokens.breakpoints.desktopLarge,
      settings: {
        slidesToScroll: 4,
        slidesToShow: 4
      }
    },
    {
      breakpoint: tokens.breakpoints.desktop,
      settings: {
        slidesToScroll: 3,
        slidesToShow: 3
      }
    },
    {
      breakpoint: tokens.breakpoints.tablet,
      settings: {
        slidesToScroll: 2,
        slidesToShow: 2
      }
    },
    {
      breakpoint: tokens.sizes.smScreen,
      settings: {
        slidesToScroll: 1,
        slidesToShow: 1
      }
    }
  ]
}

export const carouselNewsReelSettings: Settings = {
  variableWidth: true,
  slidesToScroll: 7,
  slidesToShow: 7,
  dots: false,
  infinite: false,
  speed: 500,
  swipeToSlide: true,
  responsive: [
    {
      breakpoint: tokens.breakpoints.desktopXlarge,
      settings: {
        slidesToScroll: 6,
        slidesToShow: 6
      }
    },
    {
      breakpoint: tokens.breakpoints.desktopLarge,
      settings: {
        slidesToScroll: 5,
        slidesToShow: 5
      }
    },
    {
      breakpoint: tokens.breakpoints.desktop,
      settings: {
        slidesToScroll: 3,
        slidesToShow: 4
      }
    },
    {
      breakpoint: tokens.breakpoints.tablet,
      settings: {
        slidesToScroll: 2,
        slidesToShow: 4
      }
    },
    {
      breakpoint: tokens.sizes.smScreen,
      settings: {
        slidesToScroll: 1,
        slidesToShow: 1
      }
    }
  ]
}

export const carouselHighlightedNewsReelSettings: Settings = {
  variableWidth: true,
  slidesToScroll: 6,
  slidesToShow: 6,
  dots: false,
  infinite: false,
  speed: 500,
  swipeToSlide: true,
  responsive: [
    {
      breakpoint: tokens.breakpoints.desktopXlarge,
      settings: {
        slidesToScroll: 5,
        slidesToShow: 5
      }
    },
    {
      breakpoint: tokens.breakpoints.desktopLarge,
      settings: {
        slidesToScroll: 4,
        slidesToShow: 4
      }
    },
    {
      breakpoint: tokens.breakpoints.desktop,
      settings: {
        slidesToScroll: 3,
        slidesToShow: 3
      }
    },
    {
      breakpoint: tokens.breakpoints.tablet,
      settings: {
        slidesToScroll: 2,
        slidesToShow: 3
      }
    },
    {
      breakpoint: tokens.sizes.smScreen,
      settings: {
        slidesToScroll: 1,
        slidesToShow: 1
      }
    }
  ]
}
